import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { PLANS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const PricingPlans = () => {
  const navigate = useNavigate();
  const choose = (plan) => navigate(`/contact?interest=${encodeURIComponent(`EnTrade — ${plan.name}`)}`);

  return (
    <div className="grid md:grid-cols-3 gap-5" data-testid="pricing-plans">
      {PLANS.map((plan, i) => (
        <Reveal key={plan.id} delay={i * 0.1} className="h-full">
          <div
            data-testid={`entrade-plan-${plan.id}`}
            className={`relative flex flex-col h-full rounded-sm border p-8 transition-all duration-500 hover:-translate-y-1 ${
              plan.dark
                ? "bg-coal text-ivory border-coal hover:border-pine-2/60"
                : "bg-white border-line hover:border-ink/25"
            }`}
          >
            {plan.note && (
              <span className="absolute -top-3 left-8 font-mono text-[10px] uppercase tracking-[0.15em] bg-pine text-ivory rounded-full px-3 py-1">
                {plan.note}
              </span>
            )}
            <p className={plan.dark ? "eyebrow-dark" : "eyebrow"}>{plan.name}</p>
            <p className="mt-6 text-4xl lg:text-5xl tracking-tight num">{plan.price}</p>
            <p className={`mt-1.5 text-sm ${plan.dark ? "text-[#A0A09C]" : "text-dim"}`}>{plan.period}</p>
            <ul className={`mt-8 pt-6 space-y-3 border-t flex-1 ${plan.dark ? "border-coalline" : "border-line"}`}>
              {plan.features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm">
                  <Check size={15} className={`mt-0.5 shrink-0 ${plan.dark ? "text-pine-2" : "text-pine"}`} />
                  <span className={plan.dark ? "text-[#D4D4D0]" : "text-dim"}>{f}</span>
                </li>
              ))}
            </ul>
            <button
              data-testid={`plan-cta-${plan.id}`}
              onClick={() => choose(plan)}
              className={`mt-8 w-full rounded-full py-3.5 text-sm font-medium transition-colors ${
                plan.dark ? "bg-pine-2 text-ivory hover:bg-pine" : "bg-ink text-ivory hover:bg-pine"
              }`}
            >
              {plan.cta}
            </button>
          </div>
        </Reveal>
      ))}
    </div>
  );
};

export default PricingPlans;
